<template>
  <transition name="fade">
    <div v-if="visible" class="dialog-mask" @click.self="handleClose">
      <transition name="zoom">
        <div class="dialog-box" v-show="visible" :style="{ width, borderRadius }">
          <div class="dialog-content">

            <!-- 图片类型 -->
            <template v-if="type === 'image' && image">
              <h3 v-if="title" class="dialog-title">{{ title }}</h3>
              <img :src="image" class="dialog-image" alt="dialog image"/>
              <p v-if="message" class="dialog-text">{{ message }}</p>
            </template>

            <!-- 文本类型 -->
            <template v-else-if="type === 'text'">
              <h3 v-if="title" class="dialog-title">{{ title }}</h3>
              <p v-if="message" class="dialog-text">{{ message }}</p>
            </template>

            <!-- 自定义内容 -->
            <template v-else-if="type === 'custom'">
              <slot></slot>
            </template>

          </div>

          <!-- 底部按钮 -->
          <div v-if="showActions" class="dialog-actions">
            <button
              v-if="showCancel"
              class="btn cancel"
              @click="handleCancel"
            >{{ cancelText }}
            </button>

            <button
              v-if="showConfirm"
              class="btn confirm"
              @click="handleConfirm"
            >{{ confirmText }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CenterDialog',
  props: {
    visible: {type: Boolean, default: false},
    type: {type: String, default: 'text'}, // image / text / custom
    image: {type: String, default: ''},
    title: {type: String, default: ''},
    message: {type: String, default: ''},
    showCancel: {type: Boolean, default: true},
    showConfirm: {type: Boolean, default: true},
    cancelText: {type: String, default: '取消'},
    confirmText: {type: String, default: '确定'},
    showActions: {type: Boolean, default: true},
    width: {type: String, default: '360px'},
    borderRadius: {type: String, default: '14px'},
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleCancel() {
      this.$emit('cancel')
      this.handleClose()
    },
    handleConfirm() {
      this.$emit('confirm')
      this.handleClose()
    }
  }
}
</script>

<style scoped>
/* 遮罩层，百分百占满视口，高度必须 100vh */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 弹窗主体 */
.dialog-box {
  background: #fff;
  padding: 12px;
  max-width: 80vw;
  width: auto;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  text-align: center;
  /* 💡 防止动画偏移 */
  transform-origin: center;
}

.dialog-content {
  display: flex;
  flex-direction: column;
}

.dialog-image {
  width: 100%;
  max-height: 550px;
  object-fit: cover;
}

.dialog-title {
  font-size: 20px;
  line-height: 24px;
  margin: 8px 0;
  color: #333;
}

.dialog-text {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

/* ✅ 按钮区域 */
.dialog-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 12px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  padding: 0 24px;
  border: none;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn.cancel {
  background: #eee;
}

.btn.cancel:hover {
  background: #ddd;
}

.btn.confirm {
  background: #409eff;
  color: white;
}

.btn.confirm:hover {
  background: #337ecc;
}

/* ✅ 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.zoom-enter-active, .zoom-leave-active {
  transition: all 0.25s cubic-bezier(0.3, 0.8, 0.3, 1.2);
}

.zoom-enter, .zoom-leave-to {
  transform: scale(0.85);
  opacity: 0;
}
</style>
